import { mapGetters } from 'vuex';
import mvtCollapse from '@/common/components/mvtcollapse/mvt-collapse.vue';
import mvtEstPrice from '@/common/components/mvtestprice/mvt-estprice.vue';
import dppCtaCard from '@/dpp/components/dppctacard/dpp-ctacard.vue';
import mvtClientOnly from '@/common/components/mvtclientonly/mvt-clientonly.js';

export default {
    name: 'propertyEstimate',
    inject: ['$eventBus'],
    components: {
        mvtCollapse,
        mvtEstPrice,
        dppCtaCard,
        mvtClientOnly,
    },
    props: ['disableCollapse', 'isActive', 'isMarket5YLoaded'],
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dpp', ['dpp', 'getEstRentFee']),
        isListPriceHigher() {
            return this.dpp.listingByMovoto ? this.dpp.price < this.dpp.estPrice : true;
        },
        rangeText() {
            return this.dpp.estPriceRange;
        },
        estAreaPrice() {
            return this.dpp.estPricePerArea;
        },
        estPrice() {
            return this.dpp.estPrice;
        },
        estTitle() {
            const key = this.dpp.isLand ? 'dpp.propertyEstimate.landValueCompsWithAddress' :
                'dpp.propertyEstimate.homeValueCompsWithAddress';
            return this.molang(key, {streetAddress: this.dpp.geo.address});
        }
    },
    methods: {
        ...mapGetters('glb', ['getComplianceMethod']),
        openAvmDisclaimer3() {
            this.$eventBus.$emit('property-pop-avm-disclaimer3');
        },
        openAvmDisclaimer4() {
            this.$eventBus.$emit('property-pop-avm-disclaimer4');
        },
        showNotSupportedByMLS() {
            const compliance = this.getComplianceMethod()();
            return compliance[0] && compliance[0].rule.indexOf('showNotSuportByMLS') >= 0;
        },
    },
};
